<!-- FOOTER -->
<footer id="footer">
			<!-- top footer -->
			<div class="section">
				<!-- container -->
				<div class="container">
					<!-- row -->
					<div class="row">
						<div class="col-md-3 col-xs-6">
							<div class="footer">
								<h3 class="footer-title">About Us</h3>
								<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut.</p>
								<ul class="footer-links">
									<li><a routerLink="#"><i class="fa fa-map-marker"></i>1734 Stonecoal Road</a></li>
									<li><a routerLink="#"><i class="fa fa-phone"></i>+021-95-51-84</a></li>
									<li><a routerLink="#"><i class="fa fa-envelope-o"></i>email@email.com</a></li>
								</ul>
							</div>
						</div>

						<div class="col-md-3 col-xs-6">
							<div class="footer">
								<h3 class="footer-title">Categories</h3>
								<ul class="footer-links" >
									<li *ngFor="let c of categories"><a routerLink="/product-category/{{getSlug(c.title)}}">{{c.title}}</a></li>
									
								</ul>
							</div>
						</div>

						<div class="clearfix visible-xs"></div>

						<div class="col-md-3 col-xs-6">
							<div class="footer">
								<h3 class="footer-title">Information</h3>
								<ul class="footer-links">
									<li><a routerLink="/about">About Us</a></li>
									<li><a routerLink="/contact">Contact Us</a></li>
									<li><a routerLink="/privacy-policy">Privacy Policy</a></li>
									<li><a routerLink="/orders">Orders and Returns</a></li>
									<li><a routerLink="/terms">Terms & Conditions</a></li>
								</ul>
							</div>
						</div>

						<div class="col-md-3 col-xs-6">
							<div class="footer">
								<h3 class="footer-title">Service</h3>
								<ul class="footer-links">
									<li><a routerLink="/my-account">My Account</a></li>
									<li><a routerLink="/cart">View Cart</a></li>
									<li><a routerLink="/whishlist">Wishlist</a></li>
									<li><a routerLink="track-order">Track My Order</a></li>
									<li><a routerLink="/help">Help</a></li>
								</ul>
							</div>
						</div>
					</div>
					<!-- /row -->
				</div>
				<!-- /container -->
			</div>
			<!-- /top footer -->

		</footer>
<!-- /FOOTER -->
